import { render, staticRenderFns } from "./BarrageList.vue?vue&type=template&id=ec3dc1c6&scoped=true&"
import script from "./BarrageList.vue?vue&type=script&lang=js&"
export * from "./BarrageList.vue?vue&type=script&lang=js&"
import style0 from "./BarrageList.vue?vue&type=style&index=0&id=ec3dc1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3dc1c6",
  null
  
)

export default component.exports